<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="证照借用申请" name="first">
      <LicenseApplication />
    </el-tab-pane>
    <el-tab-pane label="证照借用记录" name="second">
      <BorrowingRecord v-if="activeName ==='second' " />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import LicenseApplication from './modules/LicenseApplication';
import BorrowingRecord from './modules/BorrowingRecord';
export default {
  components: {
    LicenseApplication,
    BorrowingRecord
  },
  data () {
    return {
      activeName: 'first'
    };
  },
  methods: {
  }
};
</script>
